import React, {useState} from 'react';

const voir_plus_threshold = 200;

function get_text_preview(text) {
    if(text.length > voir_plus_threshold) {
        let spaceCharIdx = voir_plus_threshold;
        while (spaceCharIdx !== text.length && text[spaceCharIdx] !== " ") {
            spaceCharIdx += 1;
        }
        if (spaceCharIdx > voir_plus_threshold * 1.5) {
            spaceCharIdx = voir_plus_threshold;
        }
        const slice = text.substring(0, spaceCharIdx);

        if (spaceCharIdx === -1) {
            return slice + "..."; // no space found in first 100 chars
        }

        return slice.substring(0, spaceCharIdx) + " ...";
    }
    return text;
}

function get_text(the_text){
    the_text = the_text.replaceAll("&amp;", "&").replaceAll(".\n", " <br/> ").replaceAll("#", " #").replaceAll("\n", " <br/> ");
    let splitted = the_text.split(" ");
    const search_hashtag_url = "https://www.instagram.com/explore/search/keyword/?q=%23";
    const user_url = "https://www.instagram.com/";
    const final_text = splitted.map((word, i) => {

        if (word[0] === "#" || word.includes("#")) {
            return <a target="_blank" key={i} href={search_hashtag_url+word.substring(1, word.length)} className="hashtag">{word} </a>;
        } else if(word[0] === "@") {
            return <a target="_blank" key={i} href={user_url+word.substring(1, word.length)} className="user">{word} </a>;
        }else if(word === "<br/>" || word.includes("br/")){
            return <br/>;
        }
        else{
            return word + " ";
        }
    });
    return <h2>{final_text}</h2>;
}

function Article(articleInfo){

    let id = articleInfo.ids;
    const [text, setText] = useState(articleInfo.description);
    const [croppedText, setCroppedText] = useState(get_text_preview(articleInfo.description));
    const [date, setDate] = useState(articleInfo.date);
    const [image, setImage] = useState(articleInfo.img);
    const [show, setShow] = useState("plus");

    function toggleShow(){
        console.log("Show "+show);
        if(show === "plus"){
            setCroppedText(text);
            setShow("moins");
        }else{
            setShow("plus");
            setCroppedText(get_text_preview(text));
        }

    }

        return <>
            <div className={"article"}>
                <div className="containerArticle">
                    {id % 2 === 1 ?
                        <>
                            <div className="text">
                                <h3>{date}</h3>
                                {text.length > voir_plus_threshold ? <>{get_text(croppedText)} <br/><br/>
                                    <button className={"toggleShowButton"} onClick={toggleShow}>Voir {show}</button>
                                </> :get_text(text)}
                            </div>
                            <div className="image">
                                {image === null || image === '' ? <></> : <img className={"articleImage"} id={id} src={require(`../data/imgs/actualites/${image}`)} alt="Image"/>}
                            </div>
                        </>
                        :
                        <>
                    <div className="image">
                        {image === null || image === '' ? <></> : <img className={"articleImage"} id={id} src={require(`../data/imgs/actualites/${image}`)} alt="Image"/>}
                    </div>
                    <div className="text">
                        <h3>{date}</h3>
                        {text.length > voir_plus_threshold ? <>{get_text(croppedText)} <br/><br/>
                            <button className={"toggleShowButton"} onClick={toggleShow}>Voir {show}</button>
                        </> :get_text(text)}
                    </div></>
                    }
                </div>
            </div>
        </>
}



export default Article;